/**
 * The default value for Slate elements.
 */

export const defaultSlateValue = {
  object: "value",
  document: {
    object: "document",
    data: {},
    nodes: [
      {
        object: "block",
        type: "paragraph",
        data: {},
        nodes: [
          {
            object: "text",
            leaves: [{ object: "leaf", text: "", marks: [] }]
          }
        ]
      }
    ]
  }
}
